module.exports = __webpack_public_path__ + "img/VehiculoDatos.b51f10d3.svg";